import Immutable, { ImmutableObject } from 'seamless-immutable';
import * as types from '../constants/actionTypes';
import { CATEGORY_ID } from '../constants/category';
import { EVENT_SELECTION_TYPE, EVENT_TYPE, FROM_DELETE_COMMENT, PAGING_DEFAULT, PRIMARY_FILTER } from '../constants/constants';
import * as utils from '../functions/utils';
import initialState from './initialState';
import { IAction } from '../interfaces/IAction';
import { max } from 'date-fns';
import Category from 'redhotpie-shared-lib/models/category';
import categoryModel from '../models/category';
import { IFilter } from 'redhotpie-shared-lib/interfaces/IFilter';
import eventDetail from '../models/eventDetail';
import eventSearch from '../models/eventSearch';

export interface IFilterTypeCreateEvent {
  minAge: number;
  maxAge: number;
  showMeMemberType: Category;
  showMeMemberTypeDefault: Category;
}

export interface IFilterInterested {
  showMeMemberType: Category;
  membersWhoAre: number;
  initMemberType: boolean;
  isChangeFilter: boolean;
  isHasMore: boolean;
  page: number;
  isLoadingFilter: boolean;
  autoCallAPIFilter: boolean;
}

export interface IEventState {
  isShowClubDetail: boolean;
  idClubDetail: number;
  isShowCreateEditEventModal: boolean;
  isShowInterestedInEventDesktopModal: boolean;
  isShowInterestedInUserEventDesktopModal: boolean;
  isShowMyEventsModal: boolean;
  idEventSelected: number;
  isGetUserSearchSetting: boolean;
  filtersEventSearch: any;
  defaultFiltersEventSearch: any;
  isChangeFilter: boolean;
  isSearchFilter: boolean;
  listTimezone: any[];
  filtersClubSearch: any;
  dataInterested: any[];
  isLoadingInterested: boolean;
  totalEventInterested: number;
  indexPopularSelected: number;
  paramsForInterested: any;
  filtersTypeCreateEvent: IFilterTypeCreateEvent;
  filterInterested: IFilterInterested;
  defaultFilterInterested: IFilterInterested;
  isLoadingEventDetail: boolean;
  dataDetailEvent: eventDetail;
  isLoadingUserEvents: boolean;
  pageNumberUserEvents: number;
  isHasMoreUserEvents: boolean;
  dataUserEvents: any[];
  isLoadingEventOfUser: boolean;
  dataDetailEventOfUser: any;
  totalComments: number;
  eventError: boolean;
  isLoadingShareMyEvents: boolean;
  isHasMoreShareMyEvents: boolean;
  shareMyEvents: any[];
  pageNumberShareMyEvents: number;
  isLoadMoreShareMyEvents: boolean;
  isLoadingUserEventInterest: boolean;
  pageNumberUserEventInterest: number;
  isHasMoreUserEventInterest: boolean;
  dataUserEventInterest: any[];
  dataEventInterest: any[];
  isLoadingEventInterest: boolean;
  pageNumberEventInterest: number;
  totalEventInterest: number;
  isHasMoreEventInterest: boolean;
  isShowInterestedInEventModal: boolean;
  fromScreen: string;
  eventInterestId: any;
  hasExpressInterest: boolean;
  eventDateHeld: any;
  eventIndex: number;
  eventGroupIndex: number;
  eventGroupTitle: string;
  guestType?: string;
  filterHasChange: boolean;
  isLoadingEventComment: boolean;
  dataEventComment: any[];
  dataEventCommentTmp: any[];
  isHasMoreEventComment: boolean;
  isLoadingEventReply: boolean;
  isLoadMoreReply: boolean;
  isHasMoreReply: boolean;
  currentLoadMoreReply: any;
  dataEventSearch: any[];
  dataEventSearchSponsor: any[];
  isCalledEventSearchAPI: boolean;
  isCalledEventSearchSponsoredAPI: boolean;
  isLoadingEventSearch: boolean;
  isLoadingEventNonSponsored: boolean;
  isLoadingEventSearchSponsored: boolean;
  pageNumberEventSearch: number;
  pageNumberEventSearchSponsored: number;
  totalEventSearch: number;
  totalEventSearchSponsored: number;
  isHasMoreEventSearch: boolean;
  isHasMoreEventSearchSponsored: boolean;
  isLoadingCreateEvent: boolean;
  eventCategory: any[];
  clubCategory: any[];
  eventPopularState: any[];
  currentStateSelect: any;
  eventPopularStateSubUrb: any[];
  currentLocation: any;
  positionGoto: number;
  isSearchInTravel: boolean;
  isCalledSponsoredAPI: boolean;
  isCalledNoSponsoredAPI: boolean;
  clubState: any[];
  pageClubSearch: number;
  clubStateSubUrb: any[];
  dataClubSearch: any[];
  isLoadingClubEvents: boolean;
  isHasMoreClubEvents: boolean;
  isLoadedDataClubEvents: boolean;
  isLoadingDetailClubEvents: boolean;
  dataDetailClub: any;
  dataPhotoDetailClub: any[];
  clubId: number;
  isLoadingVoteComments: boolean;
  pageNumberVoteComments: number;
  isHasMoreVoteComments: boolean;
  totalVoteComments: number;
  voteComments: any[];
  isLoadingClubEvt: boolean;
  pageNumberClubEvt: number;
  isHasMoreClubEvt: boolean;
  totalClubEvt: number;
  clubEvt: any[];
  clubPastEvt: any[];
  isHasMoreClubPastEvt: boolean;
  isLoadingClubPastEvt: boolean;
  pageNumberClubPastEvt: number;
  totalClubPastEvt: number;
  suggestedUsers: any;
  suggestedUsersFilter: any;
  defaultSuggestedMemberFilters: any;
  suggestedMemberFilters: any;
  suggestedUsersFilterDefault?: any;
  eventInterestFilter?: any;
  isMyEvent?: boolean;
  hasChange?: boolean;
  isGroupChatAvailable?: boolean;
  isTicketUrlPrivate?: boolean;
  isLoadMore?: boolean;
  userId?: number;
  isLoadingTravelEvents?: boolean;
  pageNumberEventComment?: number;
  eventSelectedIndex?: number;
  typeId?: number;
  onActionOpenChatWithMember?: any;
  organiser?: any;
}

export default function eventReducer(
  state: ImmutableObject<IEventState> = initialState.eventState,
  action: IAction
): ImmutableObject<IEventState> {
  switch (action.type) {
    case types.GET_USER_SEARCH_SETTINGS_SUCCESS: {
      const { data } = action;
      const { filtersEventSearch } = Immutable.asMutable(state);
      const updateObject = {
        filtersEventSearch: {
          ...filtersEventSearch,
          searchRadius: data.filters.searchRadius,
        },
        defaultFiltersEventSearch: {
          ...filtersEventSearch,
          searchRadius: data.filters.searchRadius,
        },

        isGetUserSearchSetting: true,
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_LIST_ENTITIES_SUCCESS: {
      const { categoryId, data } = action;
      const {
        filtersTypeCreateEvent,
        filterInterested,
        defaultFilterInterested,
        suggestedMemberFilters,
        defaultSuggestedMemberFilters,
        suggestedUsersFilter,
      } = Immutable.asMutable(state);
      let updateObject = {};
      if (categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
        updateObject = {
          filtersTypeCreateEvent: {
            ...filtersTypeCreateEvent,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
            showMeMemberTypeDefault: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },

          filterInterested: {
            ...filterInterested,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
            initMemberType: true,
          },
          defaultFilterInterested: {
            ...defaultFilterInterested,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
            initMemberType: true,
          },

          suggestedMemberFilters: {
            ...suggestedMemberFilters,
            showMeMemberType: {
              contentTabs: [
                {
                  data: action.data.items,
                },
              ],
            },
          },
          defaultSuggestedMemberFilters: {
            ...defaultSuggestedMemberFilters,
            showMeMemberType: {
              contentTabs: [
                {
                  data: action.data.items,
                },
              ],
            },
          },
          suggestedUsersFilter: {
            ...suggestedUsersFilter,
            memberTypes: action.data.items,
            defaultMemberTypes: action.data.items,
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.GET_EVENT_DETAIL_SUCCESS: {
      const { data } = action;
      let dateHeld = null;
      let txtIanaName: any;
      if (data && data.detail) {
        dateHeld = data.detail.dateHeldUtcIso;
        if (data.detail.timezone && data.detail.timezone.ianaName !== '') {
          txtIanaName = data.detail.timezone.ianaName;
        }
      }
      const dateTimeObj = utils.formatDateTimeString(dateHeld, txtIanaName);
      const updateObject = {
        isLoadingEventDetail: false,
        dataDetailEvent: {
          ...state.dataDetailEvent,
          ...data,
          groupChatDetail: null,
          timeString: dateTimeObj.strTime,
          dateString: dateTimeObj.dStr,
        },
        hasExpressInterest: data.hasExpressInterest,
        totalComments: 0,
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_EVENT_SEARCH_SUCCESS: {
      const { dataEventSearch, dataEventSearchSponsor } = Immutable.asMutable(state);
      let updateObject = {};
      let data: any[] = [];
      if (action.params && action.params.sponsoredType !== 'Sponsored') {
        if (action.params && action.params.isLoadMore) {
          const temp = [...dataEventSearch];
          utils.sortDataSearch(action.data.data).forEach((item1: any) => {
            dataEventSearch.forEach((item2: any, index2: any) => {
              if (item1.title === item2.title) {
                temp[index2] = {
                  title: item2.title,
                  data: [...item2.data, ...item1.data],
                };
              } else {
                const idx = temp.findIndex(item => {
                  return item.title === item1.title;
                });
                if (idx === -1) {
                  temp.push(item1);
                }
              }
            });
          });
          data = [...temp];
        } else {
          data = utils.sortDataSearch(action.data.data);
        }
        updateObject = {
          isLoadingEventSearch: false,
          isLoadingEventNonSponsored: false,
          totalEventSearch: action.data.total,
          dataEventSearch: data,
          isHasMoreEventSearch: !(action.data.data instanceof Array && action.data.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
        };
      } else {
        updateObject = {
          isLoadingEventNonSponsored: false,
          isLoadingEventSearchSponsored: false,
          totalEventSearch: action.data.total,
          dataEventSearchSponsor:
            action.params && action.params.isLoadMore ? [...dataEventSearchSponsor, ...action.data.data] : action.data.data,
          isHasMoreEventSearch: !(action.data.data instanceof Array && action.data.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.GET_EVENT_INTERESTED_SUCCESS: {
      return state.merge({
        isLoadingInterested: false,
        dataInterested: utils.sortDataSearch(action.data.data),
        totalEventInterested: action.data.total,
        paramsForInterested: action.params,
      });
    }
    case types.GET_EVENT_SEARCH_SPONSORED_SUCCESS: {
      const { dataEventSearch, dataEventSearchSponsor } = Immutable.asMutable(state);
      let updateObject = {};
      let data: any[] = [];
      if (action.params && action.params.sponsoredType !== 'Sponsored') {
        if (action.params && action.params.isLoadMore) {
          const temp = [...dataEventSearch];
          utils.sortDataSearch(action.data.data).forEach((item1: any) => {
            dataEventSearch.forEach((item2: any, index2: any) => {
              if (item1.title === item2.title) {
                temp[index2] = {
                  title: item2.title,
                  data: [...item2.data, ...item1.data],
                };
              } else {
                const idx = temp.findIndex(item => {
                  return item.title === item1.title;
                });
                if (idx === -1) {
                  temp.push(item1);
                }
              }
            });
          });
          data = [...temp];
        } else {
          data = utils.sortDataSearch(action.data.data);
        }
        updateObject = {
          isLoadingEventSearch: false,
          // isLoadingEventSearchSponsored: false,
          isCalledEventSearchAPI: true,
          totalEventSearch: action.data.total,
          dataEventSearch: data,
          isHasMoreEventSearch: !(action.data.data instanceof Array && action.data.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
        };
      } else {
        updateObject = {
          // isLoadingEventSearch: false,
          isLoadingEventSearchSponsored: false,
          isCalledEventSearchSponsoredAPI: true,
          totalEventSearchSponsored: action.data.total,
          dataEventSearchSponsor:
            action.params && action.params.isLoadMore ? [...dataEventSearchSponsor, ...action.data.data] : action.data.data,
          isHasMoreEventSearchSponsored: !(
            action.data.data instanceof Array && action.data.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH
          ),
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.GET_MY_USER_EVENT_SUCCESS: {
      const { data } = action;
      const updateObject = {
        isLoadingEventOfUser: false,
        dataDetailEventOfUser: data,
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_USER_EVENT_SUCCESS: {
      const { dataUserEvents } = Immutable.asMutable(state);

      const updateParams = {
        isLoadingUserEvents: false,
        dataUserEvents: action.params && action.params.isLoadMore ? [...dataUserEvents, ...action.data] : action.data,
        isHasMoreUserEvents: !(action.data instanceof Array && action.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
        isLoadMore: false,
      };
      return state.merge({ ...updateParams });
    }
    case types.GET_SHARE_MY_EVENT_SUCCESS: {
      const { shareMyEvents } = Immutable.asMutable(state);

      const updateParams = {
        isLoadingShareMyEvents: false,
        shareMyEvents: action.params && action.params.isLoadMore ? [...shareMyEvents, ...action.data] : action.data,
        isHasMoreShareMyEvents: !(action.data instanceof Array && action.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
        isLoadMoreShareMyEvents: false,
      };
      return state.merge({ ...updateParams });
    }

    case types.GET_CLUB_EVENT_SUCCESS: {
      const { dataClubSearch } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingClubEvents: false,
        dataClubSearch: action.params && action.params.isLoadMore ? [...dataClubSearch, ...action.data] : action.data,
        isLoadedDataClubEvents: true,
        isHasMoreClubEvents: !(action.data instanceof Array && action.data.length < 20),
      };
      return state.merge({ ...updateParams });
    }

    case types.GET_USER_INTEREST_EVENT_SUCCESS: {
      const { dataUserEventInterest } = Immutable.asMutable(state);

      const updateParams = {
        isLoadingUserEventInterest: false,
        dataUserEventInterest: action.params && action.params.isLoadMore ? [...dataUserEventInterest, ...action.data] : action.data,
        isHasMoreUserEventInterest: Array.isArray(action.data) && !(action.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
        isLoadMore: false,
      };
      // console.log("updateParams", updateParams)
      return state.merge({ ...updateParams });
    }
    case types.GET_EVENT_COMMENT_SUCCESS: {
      const { dataEventComment, totalComments } = Immutable.asMutable(state);
      const items = action.data.items || [];
      const isHasMore = (action.data.items && action.data.items.length >= 10) || false;
      const updateParams = {
        isLoadingEventComment: false,
        dataEventComment: action.params && action.params.isLoadMore ? [...dataEventComment, ...items] : items,
        isHasMoreEventComment: isHasMore,
        totalComments: totalComments > 0 ? totalComments : action.data.totalComment || 0,
      };
      return state.merge({ ...updateParams });
    }
    case types.GET_EVENT_INTEREST_SUCCESS: {
      const { dataEventInterest } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingEventInterest: false,
        dataEventInterest: action.params && action.params.isLoadMore ? [...dataEventInterest, ...action.data.data] : action.data.data,
        totalEventInterest: action.data.total,
        isHasMoreEventInterest: Array.isArray(action.data.data) && !(action.data.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
        isLoadMore: false,
      };
      return state.merge({ ...updateParams });
    }
    case types.DELETE_EVENT_INTEREST_SUCCESS: {
      const { dataUserEventInterest } = Immutable.asMutable(state);
      const updateObject = {
        dataUserEventInterest: dataUserEventInterest.filter((item: any) => item.eventInterestId !== action.id),
      };
      return state.merge({ ...updateObject });
    }
    case types.UPDATE_STATE_EVENT_HOME: {
      return state.setIn([...action.dataKey!], action.data);
    }
    case types.SET_STATE_ENTITIES_TYPE_GUEST: {
      const { categoryId, index, flag } = action;
      if (index !== undefined) {
        state = state.setIn(['filtersTypeCreateEvent', `${categoryId}`, 'contentTabs', `${0}`, 'data', `${index}`, 'active'], flag);
      } else if (categoryId) {
        const newState: any = Immutable.asMutable(state);
        if (newState[categoryId]) {
          newState[categoryId].contentTabs[0].data.forEach((item: any, subIndex: any) => {
            if (subIndex === 0 && categoryId !== CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
              state = state.setIn(['filtersTypeCreateEvent', `${categoryId}`, 'contentTabs', 0, 'data', subIndex, 'active'], true);
            } else if (item.active !== flag) {
              state = state.setIn(['filtersTypeCreateEvent', `${categoryId}`, 'contentTabs', 0, 'data', subIndex, 'active'], flag);
            }
          });
        }
      }
      state = state.setIn(['filtersTypeCreateEvent', `${categoryId}`, 'isSelecting'], flag);
      state = state.setIn(['filtersTypeCreateEvent', `${categoryId}`, 'isSelected'], flag);
      return state.merge({ hasChange: true });
    }
    case types.MERGE_DATA_EVENT_SUCCESS: {
      return state.merge({
        ...state,
        ...action.data,
      });
    }
    case types.POST_CREATE_EVENT_SUCCESS: {
      const { dataUserEvents } = Immutable.asMutable(state);
      state = state.setIn(['dataUserEvents'], [...dataUserEvents, ...action.data]);
      state = state.setIn(['filtersTypeCreateEvent', 'minAge'], 25);
      state = state.setIn(['filtersTypeCreateEvent', 'maxAge'], 65);
      state = state.setIn(['isLoadingCreateEvent'], false);
      return state;
    }
    case types.POST_CREATE_EVENT_COMMENT_SUCCESS: {
      const { dataEventComment, totalComments } = Immutable.asMutable(state);
      const updateObject = {
        isLoadingAlert: false,
        dataEventComment: [
          {
            ...action.data,
          },
          ...dataEventComment,
        ],
        totalComments: action.params?.commentParentID || action?.params?.commentParentID === -1 ? totalComments : totalComments + 1,
      };
      return state.merge({ ...updateObject });
    }
    case types.DELETE_EVENT_COMMENT_SUCCESS: {
      const { dataEventComment, totalComments } = Immutable.asMutable(state);
      const findItem = dataEventComment.find((itm: any) => itm.commentId === action.commentId);
      const updateObject: any = {
        dataEventComment: dataEventComment.filter((item: any) => item.commentId !== action.commentId),
      };
      if (utils.hasOwnProperty(findItem, 'commentParentId') && (!findItem.commentParentId || findItem.commentParentId === -1)) {
        updateObject.totalComments = totalComments - 1;
      }

      return state.merge({ ...updateObject });
    }
    case types.GET_EVENT_CATEGORY_SUCCESS: {
      const obj = [
        {
          itemID: -1,
          itemName: 'All Events',
          listID: 0,
          isSelected: true,
        },
        ...action.data,
      ];
      return state.setIn(['eventCategory'], obj);
    }
    case types.GET_CLUB_CATEGORY_SUCCESS: {
      const obj = [
        {
          itemID: -1,
          itemName: 'All Clubs and Organisers',
          listID: 0,
          isSelected: true,
        },
        ...action.data,
      ];
      return state.setIn(['clubCategory'], obj);
    }
    case types.POST_CREATE_EVENT_INTEREST_SUCCESS:
    case types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS: {
      // params = {
      //     from: 'eventScreen' || 'eventDetail',
      //     id: searchItem.eventId,
      //     item,
      //     index,
      //     sectionTitle,
      //     isUnInterest,
      //     isMyEvent
      // };
      let { dataEventInterest, totalEventInterested, dataUserEventInterest } = Immutable.asMutable(state);
      const { dataDetailEvent, dataEventSearch, dataEventSearchSponsor, totalEventInterest, clubEvt } = Immutable.asMutable(state);
      const { from, id, index, isUnInterest, sectionTitle, isMyEvent, userIndex } = action.params;
      let updateObject = {};
      let interestCount = 1;
      if (action.type === types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS) {
        interestCount = -1;
        totalEventInterested -= 1;
      } else {
        totalEventInterested += 1;
      }
      // console.log({ totalEventInterested });
      state = state.setIn(['totalEventInterested'], totalEventInterested);
      if (from === EVENT_TYPE.EVENT_DETAIL || from === EVENT_TYPE.MY_EVENT || from === EVENT_TYPE.EVENT_SCREEN) {
        let countInterest = 0;
        const sectionIndex = dataEventSearchSponsor.findIndex((item: any) => {
          countInterest = item.searchItem.interestCount;
          return item.searchItem.eventId === id;
        });
        if (sectionIndex !== -1) {
          state = state.setIn(['dataEventSearchSponsor', sectionIndex, 'searchItem', 'hasExpressInterest'], !isUnInterest);
          state = state.setIn(
            ['dataEventSearchSponsor', sectionIndex, 'searchItem', 'interestCount'],
            isUnInterest ? countInterest - 1 : countInterest + 1
          );
        }
        const existsEventInClub = clubEvt.find((evt: any) => evt.eventId === id);
        if (existsEventInClub && index !== -1) {
          const { interestCount } = existsEventInClub;
          state = state.setIn(['clubEvt', index, 'hasExpressInterest'], !isUnInterest);
          state = state.setIn(['clubEvt', index, 'interestCount'], isUnInterest ? interestCount - 1 : interestCount + 1);
        }
        updateObject = {
          dataDetailEvent: {
            ...dataDetailEvent,
            hasExpressInterest: !isUnInterest,
          },
          totalEventInterest: isUnInterest ? totalEventInterest - 1 : totalEventInterest + 1,
          hasExpressInterest: !isUnInterest,
        };
        state = state.merge({ ...updateObject });
      }
      if (from === EVENT_TYPE.CLUB_DETAIL) {
        const existsEventInClub = clubEvt.find((evt: any) => evt.eventId === id);
        if (existsEventInClub && index !== -1) {
          const { interestCount } = existsEventInClub;
          state = state.setIn(['clubEvt', index, 'hasExpressInterest'], !isUnInterest);
          state = state.setIn(['clubEvt', index, 'interestCount'], isUnInterest ? interestCount - 1 : interestCount + 1);
        }
      }
      if (from === EVENT_TYPE.MY_EVENT || from === EVENT_TYPE.EVENT_SCREEN || (from === EVENT_TYPE.EVENT_DETAIL && sectionTitle !== null)) {
        const sectionIndex = dataEventSearch.findIndex((item: any) => {
          return item.title === sectionTitle;
        });
        if (action.index !== null && action.item !== null && sectionIndex !== -1 && index !== -1) {
          state = state.setIn(['dataEventSearch', sectionIndex, 'data', index], {
            ...dataEventSearch[sectionIndex].data[index],
            searchItem: {
              ...dataEventSearch[sectionIndex].data[index].searchItem,
              hasExpressInterest: !isUnInterest,
              interestCount: dataEventSearch[sectionIndex].data[index].searchItem.interestCount + interestCount,
            },
          });
        }
        if (from === EVENT_TYPE.EVENT_SCREEN || from === EVENT_TYPE.MY_EVENT) {
          state = state.merge({ hasExpressInterest: !isUnInterest });
        }
      }
      if (((from === EVENT_TYPE.EVENT_DETAIL && !sectionTitle) || from === EVENT_TYPE.MY_EVENT) && dataEventSearch.length > 0) {
        let indexSection = -1;
        let indexEvent = -1;
        dataEventSearch.forEach((section: any, secIndex: any) => {
          if (indexSection === -1) {
            if (section && Array.isArray(section.data)) {
              indexEvent = section.data.findIndex((evt: any) => evt.searchItem.eventId === Number.parseInt(id));
              if (indexEvent !== -1) {
                indexSection = secIndex;
              }
            }
          }
        });
        if (indexSection !== -1 && indexEvent !== -1) {
          state = state.setIn(['dataEventSearch', indexSection, 'data', indexEvent], {
            ...dataEventSearch[indexSection].data[indexEvent],
            searchItem: {
              ...dataEventSearch[indexSection].data[indexEvent].searchItem,
              hasExpressInterest: !isUnInterest,
              interestCount: dataEventSearch[indexSection].data[indexEvent].searchItem.interestCount + interestCount,
            },
          });
        }
      }
      if (isMyEvent || from === EVENT_TYPE.MY_EVENT) {
        const { dataUserEvents } = Immutable.asMutable(state);
        let countInterest = 0;
        const sectionIndex = dataUserEvents.findIndex((item: any) => {
          countInterest = item.interestCount;
          return item.eventId === parseInt(id);
        });
        if (sectionIndex !== -1) {
          state = state.setIn(['dataUserEvents', sectionIndex, 'interestCount'], isUnInterest ? countInterest - 1 : countInterest + 1);
        }
      }
      if (userIndex !== -1) {
        dataEventInterest = dataEventInterest.filter((item: any, index: any) => index !== userIndex);
        dataUserEventInterest = dataUserEventInterest.filter((item: any, index: any) => index !== userIndex);
        state = state.merge({ dataEventInterest, dataUserEventInterest });
      }
      return state;
    }
    case types.PATCH_DELETE_USER_EVENT_INTERESTED_SUCCESS: {
      let { dataUserEventInterest, dataEventInterest } = Immutable.asMutable(state);
      const { dataUserEvents, totalEventInterest, dataEventSearch } = Immutable.asMutable(state);
      const { eventIndex, ID } = action.params;
      /**
       * Logic update interestCount in dataEventSearch
       * */
      const indexGroup = dataEventSearch.findIndex(
        (gr: any) => gr.data && gr.data[eventIndex] && gr.data[eventIndex].searchItem.eventId === ID
      );
      if (indexGroup !== -1) {
        let grEventSelected =
          dataEventSearch[indexGroup] && utils.hasOwnProperty(dataEventSearch[indexGroup], 'data') && dataEventSearch[indexGroup].data;
        if (grEventSelected) {
          grEventSelected = grEventSelected.map((evt: any) => {
            if (evt.searchItem.eventId === ID) {
              return {
                ...evt,
                searchItem: {
                  ...evt.searchItem,
                  interestCount: evt.searchItem.interestCount - 1,
                },
              };
            }
            return evt;
          });
          state = state.setIn(['dataEventSearch', indexGroup, 'data'], grEventSelected);
        }
      }

      /*
       * END Logic
       * */
      /*
       * Logic update users in list Interest of MyEvents and Events
       *   dataUserEventInterest: data interest of MyEvent
       *   dataEventInterest: data interest of Events
       * */
      dataUserEventInterest = dataUserEventInterest.filter((item: any, index: any) => index !== action.params.userIndex);
      dataEventInterest = dataEventInterest.filter((itm: any, idx: any) => idx !== action.params.userIndex);
      state = state.merge({ dataUserEventInterest, dataEventInterest, totalEventInterest: totalEventInterest - 1 });
      /*
       * END Logic
       * */
      let countInterest = 0;
      const sectionIndex = dataUserEvents.findIndex((item: any) => {
        countInterest = item.interestCount;
        return item.eventId === parseInt(action.params.id);
      });
      if (sectionIndex !== -1) {
        state = state.setIn(
          ['dataUserEvents', sectionIndex, 'interestCount'],
          action.params.isUnInterest ? countInterest - 1 : countInterest + 1
        );
      } else {
        if (
          dataUserEvents[action.params.eventIndex] &&
          !!action.params.eventIndex &&
          dataUserEvents[action.params.eventIndex].interestCount
        ) {
          state = state.setIn(['dataUserEvents', action.params.eventIndex], {
            ...dataUserEvents[action.params.eventIndex],
            interestCount: dataUserEvents[action.params.eventIndex].interestCount - 1,
          });
        }
      }
      return state;
    }
    case types.PATCH_UPDATE_MY_USER_EVENT_SUCCESS: {
      // ApprovalStatus: "Pending"
      // Cost: "1"
      // DateHeld: "/Date(1565343360000-0000)/"
      // Description: "Ádasdasdasdsa"
      // DressCode: "1"
      // Email: ""
      // EventID: 58565
      // EventTitle: "Test Edit Event"
      // GoogleMapPlaceID: "ChIJq3fTG1e0j4ARtHjho-E_TTk"
      // GuestTypes: 15
      // LocationLabel: "Cupertino, CA, USA"
      // Phone: ""
      // Rules: "1asdasdas"
      // Theme: "1"
      // TicketUrl: ""
      // Website: ""

      // approvalStatus: "Pending"
      // dateHeld: "/Date(1563716160000-0000)/"
      // eventBannerUrl: "https://img.redhotpie.com.au/image/Avatars/Private2015/200x200_Private_2.jpg?v001"
      // eventId: 58565
      // eventTitle: "Asdasdsa"
      // interestCount: 0
      // location: {city: "Cupertino", state: "California", country: "United States", merge: ƒ, replace: ƒ, …}

      const { dataUserEvents } = Immutable.asMutable(state);
      const { data, index } = action;
      const locationArray = data.LocationLabel ? data.LocationLabel.split(', ') : [];
      let country = '';
      if (locationArray.length >= 2) {
        country = locationArray.length > 2 ? locationArray[2] : locationArray[1];
      }
      const location = {
        city: locationArray.length > 0 ? locationArray[0] : '',
        state: locationArray.length > 2 ? locationArray[1] : '',
        stateAbbr: locationArray.length > 2 ? locationArray[1] : '',
        country,
      };
      if (index !== undefined && dataUserEvents[index]) {
        const dataEdit = {
          ...dataUserEvents[index],
          dateHeld: data.DateHeld,
          eventTitle: data.EventTitle,
          location,
        };

        return state.setIn(['dataUserEvents', index], dataEdit);
      }
      return state;
    }
    case types.GET_EVENT_REPLY_SUCCESS: {
      // params = {
      //  size: size show reply,
      //  /* param for load more reply */
      //  commentParentID: id comment parent
      // }
      const { dataEventComment } = Immutable.asMutable(state);
      const newCommentParent: any[] = [];
      const items = (action.data && action.data.items) || [];
      if (action.params.commentParentID !== undefined) {
        // Function for load more
        dataEventComment.forEach((evt: any) => {
          if (evt.commentId === action.params.commentParentID) {
            evt = {
              ...evt,
              isHasMoreReply: items.length === (action.params.pageSize ? action.params.pageSize : 10),
              pageNumber: action.params.page >= 2 && items.length > 0 ? action.params.page : -1,
            };
          }
          newCommentParent.push(evt);
        });
      } else {
        dataEventComment.forEach((evt: any) => {
          const idComment = evt.commentId;
          let count = 0;
          items.forEach((itm: any) => {
            if (itm.commentParentId === idComment) {
              count += 1;
            }
          });
          if (count >= (action.params.size ? action.params.size : 10)) {
            evt = {
              ...evt,
              isHasMoreReply: true,
              pageNumber: 1,
            };
          }
          newCommentParent.push(evt);
        });
      }

      return state.merge({
        dataEventComment: [...newCommentParent, ...items],
        dataEventCommentTmp: [...newCommentParent, ...items],
      });
    }
    case types.GET_EVENT_REPLY_SHOW_MORE_SHOW_LESS: {
      const { dataEventComment, dataEventCommentTmp } = state;
      const idCommentParent = action.params.commentParentID;
      const isShowMore = !dataEventComment[action.params.index].isHasMoreReply;

      const idxCommentParent = action.params.index;
      let newDataEventComment = dataEventComment.asMutable().filter((itm: any) => itm.commentParentId !== idCommentParent);
      let countReply = 0;
      const newDataEventReply = dataEventCommentTmp.asMutable().filter((itm: any) => {
        if (itm.commentParentId === idCommentParent && countReply < (isShowMore ? 3 : dataEventComment.length)) {
          countReply += 1;
          return itm;
        }
        return null;
      });

      newDataEventComment = [...newDataEventComment, ...newDataEventReply];

      newDataEventComment[idxCommentParent] = {
        ...newDataEventComment[idxCommentParent],
        isHasMoreReply: isShowMore,
      };

      return state.merge({ dataEventComment: [...newDataEventComment] });
    }
    case types.GET_EVENT_POPULAR_COUNT_SUCCESS: {
      const { data, googleMapPlaceID } = action;
      let updateObject = {};
      if (googleMapPlaceID === undefined || !googleMapPlaceID) {
        updateObject = {
          eventPopularState: data,
        };
      } else {
        updateObject = {
          eventPopularStateSubUrb: data,
          currentStateSelect: googleMapPlaceID,
        };
      }

      return state.merge({ ...updateObject });
    }
    case types.GET_CLUB_COUNT_SUCCESS: {
      const { data, googleMapPlaceID } = action;
      let updateObject = {};
      if (googleMapPlaceID === undefined || !googleMapPlaceID) {
        updateObject = {
          clubState: data,
        };
      } else {
        updateObject = {
          clubStateSubUrb: data,
          currentStateSelect: googleMapPlaceID,
        };
      }

      return state.merge({ ...updateObject });
    }
    case types.USER_LOGOUT_SUCCESS: {
      return initialState.eventState;
    }
    case types.PATCH_DELETE_EVENT_SUCCESS: {
      const { dataUserEvents } = Immutable.asMutable(state);
      return state.merge({
        dataUserEvents: dataUserEvents.filter((item: any) => item.eventId !== action.params.eventId),
      });
    }
    case types.POST_CREATE_COMMENT_LIKE_SUCCESS: {
      const { dataEventComment } = Immutable.asMutable(state);
      const { cmdId } = action.data;
      const newEventComment: any[] = [];
      dataEventComment.forEach((itm: any) => {
        if (itm.commentId === cmdId) {
          let newData = itm;
          newData = {
            ...newData,
            isLiked: true,
            likeCount: (itm.likeCount ? itm.likeCount : 0) + 1,
          };
          newEventComment.push(newData);
        } else {
          newEventComment.push(itm);
        }
      });

      return state.merge({ dataEventComment: newEventComment });
    }
    case types.DELETE_COMMENT_LIKE_SUCCESS: {
      const { dataEventComment } = Immutable.asMutable(state);
      const { cmdId } = action.data;
      const newEventComment: any[] = [];
      dataEventComment.forEach((itm: any) => {
        if (itm.commentId === cmdId) {
          let newData = itm;
          newData = {
            ...newData,
            isLiked: false,
            likeCount: itm.likeCount - 1 < 0 ? 0 : itm.likeCount - 1,
          };
          newEventComment.push(newData);
        } else {
          newEventComment.push(itm);
        }
      });

      return state.merge({ dataEventComment: newEventComment });
    }
    case types.TOGGLE_CREATE_EDIT_EVENT_MODAL: {
      return state.set('isShowCreateEditEventModal', action.data);
    }
    case types.TOGGLE_MY_EVENTS_MODAL: {
      return state.set('isShowMyEventsModal', action.data);
    }
    case types.TOGGLE_INTERESTED_IN_EVENT_DESKTOP_MODAL: {
      return state.set('isShowInterestedInEventDesktopModal', action.data);
    }
    case types.TOGGLE_INTERESTED_IN_USER_EVENT_DESKTOP_MODAL: {
      return state.set('isShowInterestedInUserEventDesktopModal', action.data);
    }
    case types.REQUEST_GET_DETAIL_CLUB_EVENT: {
      return state.set('isLoadingDetailClubEvents', action.data.isLoadingDetailClubEvents);
    }
    case types.GET_DETAIL_CLUB_EVENT_SUCCESS: {
      // Reassigning state variable is not effective if it's a const argument,
      // but here 'state' is the argument, so we can reassign it locally,
      // but standard reducer pattern is to return new state.
      // ImmutableJS methods return new state, so chaining is better.
      let nextState = state.set('isLoadingDetailClubEvents', false);
      nextState = nextState.set('dataDetailClub', action.data);
      return nextState;
    }

    case types.GET_DETAIL_CLUB_EVENT_FAIL: {
      return state.set('isLoadingDetailClubEvents', action.data.isLoadingDetailClubEvents);
    }

    case types.GET_PHOTO_DETAIL_CLUB_SUCCESS: {
      return state.set('dataPhotoDetailClub', action.data);
    }

    case types.GET_TIMEZONE_SUCCESS: {
      return state.set('listTimezone', action.data);
    }

    case types.GET_CLUB_EVT_SUCCESS: {
      const { clubEvt, totalClubEvt, clubPastEvt, totalClubPastEvt } = Immutable.asMutable(state);
      const { page, type } = action.params;
      if (type === EVENT_SELECTION_TYPE.PAST) {
        return state.merge({
          isLoadingClubPastEvt: false,
          pageNumberClubPastEvt: page,
          isHasMoreClubPastEvt: action.data.length === action.params.size,
          clubPastEvt: page === 1 ? action.data : [...clubPastEvt, ...action.data],
          totalClubPastEvt: page === 1 ? action.total : totalClubPastEvt + (action.total || 0),
        });
      }
      return state.merge({
        isLoadingClubEvt: false,
        pageNumberClubEvt: page,
        isHasMoreClubEvt: action.data.length === action.params.size,
        clubEvt: page === 1 ? action.data : [...clubEvt, ...action.data],
        totalClubEvt: page === 1 ? action.total : totalClubEvt + (action.total || 0),
      });
    }
    case types.BLOCK_USER: {
      const { voteComments } = Immutable.asMutable(state);
      const voteFilter = voteComments.filter((v: any) => v.comment.profile.userId !== action.data);
      return state.merge({ voteComments: voteFilter });
    }

    case types.CLOSE_CLUB_DETAIL: {
      return state.merge({
        dataDetailClub: {},
        dataPhotoDetailClub: [],
        clubId: -1,
        isLoadingClubEvt: false,
        pageNumberClubEvt: 1,
        isHasMoreClubEvt: false,
        totalClubEvt: 0,
        clubEvt: [],
        isLoadingVoteComments: false,
        pageNumberVoteComments: 1,
        isHasMoreVoteComments: false,
        voteComments: [],
      });
    }
    case types.POST_SHOW_HIDDEN_TICKET_LINK: {
      const { dataUserEventInterest, isMyEvent, dataEventInterest } = Immutable.asMutable(state);
      let newInterest;
      if (isMyEvent) {
        newInterest = dataUserEventInterest.map((user: any) => {
          return {
            ...user,
            hasTicketAccess: user.profile.userId === action.userId ? !user.hasTicketAccess : user.hasTicketAccess,
          };
        });
      } else {
        newInterest = dataEventInterest.map((user: any) => {
          return {
            ...user,
            hasTicketAccess:
              user.eventId === action.params.eventId && user.interestId === action.params.interestId
                ? !user.hasTicketAccess
                : user.hasTicketAccess,
          };
        });
      }

      return state.merge({
        [isMyEvent ? 'dataUserEventInterest' : 'dataEventInterest']: newInterest,
      });
    }
    case types.POST_INVITE_REMOVE_GROUP_CHAT: {
      const { dataUserEventInterest, isMyEvent, dataEventInterest, filterInterested, filterHasChange } = state;
      const { membersWhoAre } = filterInterested;
      let newInterest;
      if (isMyEvent) {
        if (filterHasChange && membersWhoAre !== PRIMARY_FILTER.ALL) {
          newInterest = dataUserEventInterest.filter((user: any) => user.profile.userId !== action.userId);
        } else {
          newInterest = dataUserEventInterest.map((user: any) => {
            return {
              ...user,
              hasGroupChatAccess: user.profile.userId === action.userId ? !user.hasGroupChatAccess : user.hasGroupChatAccess,
            };
          });
        }
      } else {
        if (filterHasChange && membersWhoAre !== PRIMARY_FILTER.ALL) {
          newInterest = dataEventInterest.filter(
            (user: any) => user.eventId === action.params.eventId && user.interestId !== action.params.interestId
          );
        } else {
          newInterest = dataEventInterest.map((user: any) => {
            return {
              ...user,
              hasGroupChatAccess:
                user.eventId === action.params.eventId && user.interestId === action.params.interestId
                  ? !user.hasGroupChatAccess
                  : user.hasGroupChatAccess,
            };
          });
        }
      }

      return state.merge({
        [isMyEvent ? 'dataUserEventInterest' : 'dataEventInterest']: newInterest,
      });
    }
    case types.UPDATE_STATE_EVENT_DETAIL: {
      const { dataDetailEvent } = Immutable.asMutable(state);
      return state.merge({
        dataDetailEvent: {
          ...dataDetailEvent,
          ...action.data,
        },
      });
    }
    case types.UPDATE_USER_PHOTO_GROUP_CHAT: {
      const {
        dataDetailEvent: { groupChatDetail },
      } = Immutable.asMutable(state);
      const { data, index } = action;
      if (index !== undefined && groupChatDetail) {
        return state.setIn(['dataDetailEvent', 'groupChatDetail', 'roomMembers', `${index}`], {
          ...groupChatDetail.roomMembers[index],
          mainPhoto: {
            thumbUrl: data ? data.thumbUrl : '',
            fullUrl: data ? data.fullUrl : '',
          },
        });
      }
      return state;
    }
    case types.END_GROUP_CHAT_SUCCESS: {
      // const {
      //     dataDetailEvent: {groupChatDetail},
      // } = Immutable.asMutable(state);
      // const {roomJid} = action.params;
      // if (groupChatDetail && groupChatDetail.roomJid === roomJid) {
      //     return state.setIn(['dataDetailEvent', 'groupChatDetail', 'roomMembers'], []);
      // }
      return state;
    }
    case types.UPDATE_STATE_GROUP_CHAT: {
      const { params } = action;
      return state.setIn(['dataDetailEvent', 'groupChatDetail', ...params.dataKey], params.value);
    }
    case types.DELETE_EVENT_INTEREST_BY_OWNER_SUCCESS: {
      const { params } = action;
      const { dataEventInterest, dataUserEventInterest, totalEventInterest, dataEventSearchSponsor, dataEventSearch, dataUserEvents } =
        Immutable.asMutable(state);
      // console.log({ dataEventSearch });
      // update totalInterest in search sponsor
      let indexSearchSponsor = -1;
      let itemSearchSponsor = null;
      if (dataEventSearchSponsor) {
        for (let i = 0; i < dataEventSearchSponsor.length; i++) {
          const item = dataEventSearchSponsor[i];
          if (item.searchItem.eventId === params.eventId) {
            indexSearchSponsor = i;
            itemSearchSponsor = item;
            break;
          }
        }
        if (indexSearchSponsor !== -1) {
          state = state.setIn(
            ['dataEventSearchSponsor', indexSearchSponsor, 'searchItem', 'interestCount'],
            itemSearchSponsor.searchItem.interestCount - 1
          );
        }
      }
      // Update Event Search
      let indexOutsite = -1;
      let indexInsite = -1;
      let itemEventSearch = null;
      if (dataEventSearch) {
        for (let i = 0; i < dataEventSearch.length; i++) {
          for (let j = 0; j < dataEventSearch[i].data.length; j++) {
            let item = dataEventSearch[i].data[j];
            if (item.searchItem.eventId === params.eventId) {
              indexInsite = j;
              indexOutsite = i;
              itemEventSearch = item;
              break;
            }
          }
          if (indexInsite !== -1) {
            break;
          }
        }
      }
      if (indexInsite !== -1) {
        state = state.setIn(
          ['dataEventSearch', `${indexOutsite}`, 'data', `${indexInsite}`, 'searchItem', 'interestCount'],
          itemEventSearch.searchItem.interestCount - 1
        );
      }
      // Update data user events
      let indexUserEvent = -1;
      let itemUserEvent = null;
      if (dataUserEvents) {
        for (let i = 0; i < dataUserEvents.length; i++) {
          const item = dataUserEvents[i];
          if (item.eventId === params.eventId) {
            indexUserEvent = i;
            itemUserEvent = item;
          }
        }
      }
      if (indexUserEvent !== -1) {
        state = state.setIn(['dataUserEvents', indexUserEvent, 'interestCount'], itemUserEvent.interestCount - 1);
      }

      return state.merge({
        totalEventInterest: totalEventInterest - 1,
        dataEventInterest: dataEventInterest.filter((u: any) => u.interestId !== params.interestId),
        dataUserEventInterest: dataUserEventInterest.filter((u: any) => u.eventInterestId !== params.interestId),
      });
    }

    case types.DELETE_PARENT_OWNED_COMMENT: {
      const { dataEventComment, totalComments } = Immutable.asMutable(state);
      const { from, commentId } = action.params;
      if (from && from === FROM_DELETE_COMMENT.EVENT) {
        const findItem = dataEventComment.find((itm: any) => itm.commentId === commentId);
        const updateObject: any = {
          dataEventComment: dataEventComment.filter((item: any) => item.commentId !== commentId),
        };
        if (utils.hasOwnProperty(findItem, 'commentParentId') && (!findItem.commentParentId || findItem.commentParentId === -1)) {
          updateObject.totalComments = totalComments - 1;
        }

        return state.merge({ ...updateObject });
      }
      return state;
    }

    case types.DELETE_ALL_USER_EVENT_GROUP_CHAT: {
      const { dataDetailEvent, dataEventInterest, dataUserEventInterest } = Immutable.asMutable(state);
      const newEventInterest = dataEventInterest
        ? dataEventInterest.map((itm: any) => {
            return {
              ...itm,
              hasGroupChatAccess: false,
            };
          })
        : [];
      const newUserEventInterest = dataUserEventInterest
        ? dataUserEventInterest.map((itm: any) => {
            return {
              ...itm,
              hasGroupChatAccess: false,
            };
          })
        : [];
      return state.merge({
        isGroupChatAvailable: true,
        dataDetailEvent: {
          ...dataDetailEvent,
          groupChatDetail: undefined,
          isGroupChatAvailable: false,
        },
        dataEventInterest: newEventInterest,
        dataUserEventInterest: newUserEventInterest,
      });
    }

    case types.MERGE_FILTER_INTERESTED: {
      const { params } = action;
      const { filterInterested } = Immutable.asMutable(state);

      return state.merge({
        filterInterested: {
          ...filterInterested,
          ...params,
        },
      });
    }

    case types.GET_EVENT_SUGGESTED_USERS_REQUEST: {
      const { page } = action;
      const { suggestedUsers } = Immutable.asMutable(state);
      if (page === 1) {
        return state.setIn(['suggestedUsers', 'isLoading'], true);
      }
      return state.merge({
        suggestedUsers: {
          ...suggestedUsers,
          isLoadingMore: true,
        },
      });
    }
    case types.GET_EVENT_SUGGESTED_USERS_SUCCESS: {
      const { suggestedUsers } = Immutable.asMutable(state);
      const { data, paginationInfo } = action;
      const _suggestedUsers = JSON.parse(JSON.stringify(suggestedUsers));
      const newData = paginationInfo.page === 1 ? data : [..._suggestedUsers.data, ...data];
      const updateObj = {
        data: newData,
        isLoading: false,
        isLoadingMore: false,
        pageNumber: paginationInfo.page,
        total: paginationInfo.total,
        isHasMore: paginationInfo.searchGuid ? data.length === paginationInfo.size : newData.length < paginationInfo.total,
        searchGuid: paginationInfo.searchGuid || '',
      };
      return state.setIn(['suggestedUsers'], updateObj);
    }
    case types.UPDATE_EVENT_SUGGESTED_USER_FILTER: {
      const { suggestedUsersFilter } = Immutable.asMutable(state);
      const { data } = action;
      const updateObj = {
        ...suggestedUsersFilter,
        ...data,
        isHasChangeFilter: data.userName && suggestedUsersFilter?.isHasChangeFilter ? true : data.isHasChangeFilter,
        isApplyFilter: data.userName && suggestedUsersFilter.isApplyFilter ? true : data.isApplyFilter,
      };
      return state.setIn(['suggestedUsersFilter'], updateObj);
    }
    case types.RESET_EVENT_SUGGESTED_USER_FILTER: {
      const { suggestedUsersFilter } = Immutable.asMutable(state);
      const updateObj = {
        ...suggestedUsersFilter,
        memberTypes: suggestedUsersFilter.defaultMemberTypes,
        minAge: 18,
        maxAge: 99,
        location: {},
        searchRadius: 100,
        isHasChangeFilter: false,
        isApplyFilter: false,
      };
      return state.setIn(['suggestedUsersFilter'], updateObj);
    }

    default:
      return state;
  }
}
